import { TermsAndConditionsPage } from '~/components/TermsAndConditionsPage/TermsAndConditionsPage'

export default function TermsPage() {
  return <TermsAndConditionsPage />
}
